import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-categories/stats`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const stats = {
  get: apiPathFunc(pathBase),
};
